module.exports = __webpack_public_path__ + "1879c231c56d25f0b7bb85b02fac65da.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-420.jpg
// module id = 473
// module chunks = 0